export const DAYFORCE_SHIFTS_DEFAULT_TIMEZONE = 'America/New_York' as const

export const DayforceWebhookEventTypes: Record<string, string> = {
  contested_hours_approved: 'Contested Hours Approved',
  contested_hours_denied: 'Contested Hours Denied',
  contested_hours_edited: 'Contested Hours Edited',
  job_canceled: 'Job Canceled',
  job_invitation: 'Job Invitation',
  job_updated: 'Job Updated',
  shift_payout_added: 'Shift Payout Added',
  shift_payout_deleted: 'Shift Payout Deleted',
  shift_payout_updated: 'Shift Payout Updated',
  shift_updated: 'Shift Updated',
  worker_ncns: 'Worker No-Show',
  worker_rated: 'Worker Rated',
  worker_reported: 'Worker Reported',
  worker_clocked_in: 'Worker Clocked In',
  worker_clocked_out: 'Worker Clocked Out',
  worker_clock_out_allowed: 'Worker Clock Out Allowed',
} as const

export type DayforceWebhookEventType = keyof typeof DayforceWebhookEventTypes

export const DayforceWebhookStatus: Record<string, string> = {
  created: 'Created',
  attempted: 'Attempted',
  failed: 'Failed',
  completed: 'Completed',
  invalid_payload: 'Invalid Payload',
  ignored: 'Ignored',
}

export type DayforceWebhookStatus = keyof typeof DayforceWebhookStatus

export const DayforceShiftTypes: Record<string, string> = {
  backup: 'Backup',
  removed: 'Removed',
  reported: 'Reported',
  standard: 'Standard',
  temporary: 'Temporary',
  worker_submission: 'Worker Submission',
  worker_submission_pending: 'Worker Submission Pending',
}

export type DayforceShiftType = keyof typeof DayforceShiftTypes

export const DAYFORCE_SHIFT_TYPES_ACTIVE: DayforceShiftType[] = [
  'backup',
  'reported',
  'standard',
  'temporary',
  'worker_submission',
  'worker_submission_pending',
]

export const DAYFORCE_SHIFT_TYPES_REMOVED: DayforceShiftType[] = ['removed']

export const DayforceShiftAssociationTypes: Record<string, string> = {
  open: 'Open',
  specific_workers_requested: 'Specific Workers Requested',
}

export type DayforceShiftAssociationType =
  keyof typeof DayforceShiftAssociationTypes
